import React from 'react';
import classnames from 'classnames';

import styles from './ProfileRing.module.scss';

const DEFAULT_PHOTO =
  'https://image.shutterstock.com/image-vector/user-avatar-icon-sign-profile-260nw-1145752283.jpg';

export interface Props {
  photo?: string;
  color?: string;
}

// TODO: Add all variants
export default function ProfileRing({photo = DEFAULT_PHOTO, color}: Props) {
  const imageClassName = classnames(
    styles.ProfileRing,
    color === 'blue' && styles.blue,
    color === 'green' && styles.green,
    color === 'black' && styles.black,
  );

  return <img className={imageClassName} src={photo} alt="Profile" />;
}
